import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer } from "antd";

import './style.scss';

interface propsInterface {
  open: boolean;
  onClose: Function;
  children: React.ReactNode;
  getContainer: string;
}

const DrawerRight = ({ open, onClose, children, getContainer }: propsInterface ) => {
  return (
    <Drawer
      open={open}
      placement="right"
      onClose={() => onClose()}
      closeIcon={<FontAwesomeIcon icon="arrow-right" />}
      destroyOnClose={true}
      mask={false}
      width={490}
      getContainer={getContainer}
      className='v-drawer'
    >
      {children}
    </Drawer>
  )
}

export default DrawerRight;